import { render, staticRenderFns } from "./HtmlEditorField.vue?vue&type=template&id=873029a6&scoped=true"
import script from "./HtmlEditorField.vue?vue&type=script&lang=js"
export * from "./HtmlEditorField.vue?vue&type=script&lang=js"
import style0 from "./HtmlEditorField.vue?vue&type=style&index=0&id=873029a6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "873029a6",
  null
  
)

export default component.exports